if ("function" != typeof ProductQuantity) {
  class e extends HTMLElement {
    constructor() {
      super();
      let e = this.querySelector(".qty-selector"),
        t = this.querySelector(".qty-minus"),
        s = this.querySelector(".qty-plus"),
        i = e.getAttribute("min") ? parseInt(e.getAttribute("min")) : 1,
        a = e.getAttribute("max") ? parseInt(e.getAttribute("max")) : 999;
      parseInt(e.value) - 1 < i && t.classList.add("disabled"),
        parseInt(e.value) + 1 > a && s.classList.add("disabled"),
        t.addEventListener("click", (a) => {
          if ((a.preventDefault(), !t.classList.contains("disabled"))) {
            let l = parseInt(e.value);
            l - 1 >= i && ((e.value = l - 1), s.classList.remove("disabled")),
              l - 1 <= i && t.classList.add("disabled");
          }
        }),
        s.addEventListener("click", (i) => {
          if ((i.preventDefault(), !s.classList.contains("disabled"))) {
            let l = parseInt(e.value);
            l + 1 <= a && ((e.value = l + 1), t.classList.remove("disabled")),
              l + 1 >= a && s.classList.add("disabled");
          }
        });
    }
  }
  void 0 === customElements.get("product-quantity") &&
    customElements.define("product-quantity", e);
}
